import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-FlagBangladesh-mengjialaguo",
  "use": "icon-FlagBangladesh-mengjialaguo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-FlagBangladesh-mengjialaguo\"><defs><style type=\"text/css\"></style></defs><path d=\"M18.618182 186.181818h977.454545v651.636364H18.618182z\" fill=\"#167A61\" p-id=\"4771\" /><path d=\"M507.345455 512m-190.836364 0a190.836364 190.836364 0 1 0 381.672727 0 190.836364 190.836364 0 1 0-381.672727 0Z\" fill=\"#C9444F\" p-id=\"4772\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol